/* eslint-disable global-require */
import React from 'react';
import styled from 'styled-components';
import { Portal } from 'react-portal';

import { Container } from '@pegasus/ui-components/legacy/layout';
import { FlashMessageContainer } from '@pegasus/ui-flashmessages/components/flashmessages';

import { Spacer } from '@pegasus/ui-headers/components/Spacer';

import { HeaderWrapper } from '../../shared/header';
import { useCustomerInfoWithPrefetch } from '../../shared/CustomerInfo/redux/hooks';
import { SideMenu } from '../SideMenu';
import { BackToTop } from '../shared/BackToTop';
import { ChatBoxContainer } from '../shared/ChatBoxContainer';
import { useFlashMessagesWithPrefetch } from '../../shared/flash-messages/redux/hooks';
import { FooterWrapper } from '../../shared/footer/wrapper';
import { FixedButtonsWrapper, FlashMessageContainerWrapper } from '../Core';

import { TranslateScope } from '@pegasus/translation/components';

const SideMenuWrapper = styled.div`
    position: absolute;
    left: 0;
    right: 0;

    ${Container} {
        position: absolute;
        left: 0;
        right: 0;
    }
`;

export const LegacyLayout = ({ isGuest = false }: { isGuest?: boolean }) => {
    const messages = useFlashMessagesWithPrefetch();
    useCustomerInfoWithPrefetch(isGuest);

    const menuElement = document && document.getElementById('menu');

    return (
        <>
            <Portal node={document && document.getElementById('header')}>
                <TranslateScope>
                    <HeaderWrapper isGuest={isGuest} />
                </TranslateScope>
                <FlashMessageContainerWrapper>
                    <Spacer />
                    <FlashMessageContainer messages={messages} />
                </FlashMessageContainerWrapper>
            </Portal>
            {menuElement && (
                <Portal node={menuElement}>
                    <SideMenuWrapper>
                        <Container>
                            <Spacer />
                            <SideMenu isLegacy />
                        </Container>
                    </SideMenuWrapper>
                </Portal>
            )}
            <FixedButtonsWrapper>
                <ChatBoxContainer />
                <BackToTop />
            </FixedButtonsWrapper>
            <Portal node={document && document.getElementById('footer')}>
                <TranslateScope>
                    <FooterWrapper />
                </TranslateScope>
            </Portal>
        </>
    );
};
